import React from 'react'
import PropTypes from 'prop-types'
import {
  CloseButton,
  ModalBodyCopy,
  ContainedButton,
  BackpackSuccess as SuccessIcon,
} from 'secondstep-components'
import {
  ButtonsWrapperSuccess,
  SuccessModalWrapper,
  Header,
  SubHeader,
} from './component.styles'
import { toUrlSafe } from 'utils/stringHelpers'
import {
  HEADER_SUCCESS,
  BODY_TYPE_PREFIX_CLASS,
  BODY_TEXT_CREATE,
  BODY_TEXT_EDIT,
  BUTTON_SUBMIT,
  MAX_CLASSES_REACHED,
} from './constants'

const propTypes = {
  currentSite: PropTypes.shape({
    isSetup: PropTypes.bool,
    siteId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    siteName: PropTypes.string,
  }),
  dataTestId: PropTypes.string,
  debugContext: PropTypes.object,
  handleCancel: PropTypes.func,
  handleClose: PropTypes.func,
  handleSubmit: PropTypes.func,
  maxClassesReached: PropTypes.bool,
  navigationEvent: PropTypes.func,
  redirectToMyClasses: PropTypes.func,
  selectedSchool: PropTypes.shape({
    siteId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  successFor: PropTypes.string,
  title: PropTypes.string.isRequired,
}

const Success = ({
  currentSite,
  dataTestId,
  handleClose,
  handleSubmit,
  maxClassesReached,
  selectedSchool,
  successFor,
  debugContext,
  title,
  navigationEvent,
  redirectToMyClasses,
}) => {
  const edit = successFor === 'Edit'
  const modalSize = edit ? 'small' : null
  const bodyText = edit ? BODY_TEXT_EDIT : BODY_TEXT_CREATE

  // Create a custom click handler that ensures the correct site is selected
  const handleSubmitWithSiteParam = () => {
    try {
      if (successFor !== 'Edit') {
        const selectedSiteId = selectedSchool?.siteId
        const currentSiteId = currentSite?.siteId

        if (selectedSiteId && selectedSiteId !== currentSiteId) {
          const currentUrl = window.location.href
          const url = new URL(currentUrl)
          url.searchParams.set('site', selectedSiteId)
          const finalPath = `${url.pathname}${url.search}${url.hash}`
          try {
            // Show loading while we switch
            if (window?.appStore?.dispatch) {
              try {
                const {
                  operations: loadingOperations,
                } = require('store/loadingManager')
                window.appStore.dispatch(
                  loadingOperations.setIsLoadingState('Switching site...'),
                )
              } catch (_) {}
            }
            // Prefer app router: replace current URL, then reload
            if (navigationEvent) {
              navigationEvent(finalPath, 'REPLACE')
              window.location.reload()
            } else if (redirectToMyClasses) {
              redirectToMyClasses(finalPath)
              window.location.reload()
            } else {
              window.location.href = finalPath
            }
          } catch (e) {
            // eslint-disable-next-line no-console
            console.error(
              '[CreateInstanceShared] Success router replace+reload failed',
              e,
            )
            window.location.href = finalPath
          } finally {
            if (window?.appStore?.dispatch) {
              try {
                const {
                  operations: loadingOperations,
                } = require('store/loadingManager')
                window.appStore.dispatch(loadingOperations.setNotLoadingState())
              } catch (_) {}
            }
          }
          return
        }
      }
    } catch (e) {
      // If anything goes wrong with URL manipulation, fall back to normal submit
      // eslint-disable-next-line no-console
      console.error('[CreateInstanceShared] Success URL update failed', e)
    }
    if (handleSubmit) handleSubmit()
  }
  return (
    <SuccessModalWrapper dataTestId={dataTestId} size={modalSize}>
      <CloseButton dataTestId="button-close" onClick={handleClose} />
      <SuccessIcon dataTestId="icon-success" />
      <Header dataTestId="modal-success-header">{HEADER_SUCCESS}</Header>
      <SubHeader data-testid="modal-success-subheader">
        {`${bodyText} ${title} ${BODY_TYPE_PREFIX_CLASS}`}
      </SubHeader>
      {maxClassesReached && (
        <ModalBodyCopy data-testid="modal-success-max-classes-reached">
          {MAX_CLASSES_REACHED}
        </ModalBodyCopy>
      )}
      <ButtonsWrapperSuccess>
        <ContainedButton
          dataTestId={`button-${toUrlSafe(BUTTON_SUBMIT)}`}
          onClick={handleSubmitWithSiteParam}
        >
          {BUTTON_SUBMIT}
        </ContainedButton>
      </ButtonsWrapperSuccess>
    </SuccessModalWrapper>
  )
}

Success.propTypes = propTypes

export default Success
